import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import MUIDialogActions, { DialogActionsProps } from '@mui/material/DialogActions';
import MUIDialogContent, { DialogContentProps } from '@mui/material/DialogContent';
import MUIDialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';

export const Dialog = (props: MuiDialogProps) => {
	return <MuiDialog {...props} />;
};

export interface IDialogTitleProps extends Pick<DialogTitleProps, 'children'> {}

export const DialogTitle = (props: IDialogTitleProps) => {
	return <MUIDialogTitle {...props} />;
};

export interface IDialogContentProps extends Pick<DialogContentProps, 'children' | 'style' | 'dividers'> {}

export const DialogContent = (props: IDialogContentProps) => {
	return <MUIDialogContent {...props} />;
};

export interface IDialogActionsProps extends Pick<DialogActionsProps, 'children'> {}

export const DialogActions = (props: IDialogContentProps) => {
	return <MUIDialogActions {...props} />;
};
